<template id="filler-template">
  <div>
    <div class="flash-message" style="display: none;">
      <div class="alert alert-success">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">x</span>
        </button>
      </div>
    </div>
    <vueup></vueup>
    <form class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div>
          <selector
              v-show="(!isAllowPosterCreation || formAction === 'create')"
              @on-template-selected="changeFlagTemplateSelected"
              :campaign-description="campaignDescription"
              @ready="fetchPosterToEdit"
              :template-id="templateId"
              :id-theme="themeId"
              :action="action"
              :sub-domain="subDomain"
              :poster-id="posterId"
              :default-content="defaultContent"
              :poster-permissions="posterPermissions"
              :create-from-register="createFromRegister">
          </selector>
        </div>
        <template v-if="posterId">
          <div v-if="hasTemplateSelected">
            <product :sub-domain="subDomain"></product>
          </div>
        </template>
        <template v-else>
          <div v-show="hasTemplateSelected">
            <product :sub-domain="subDomain"></product>
          </div>
        </template>
      </div>
      <div class="col-12 col-sm-6 col-md-3" v-if="hasTemplateSelected">
        <div v-show="!justUpdateContent">
          <div class="card-header"><span class="title">PREÇO</span></div>
          <div class="panel-body">
            <fields-carrefour
                v-if="isCarrefour"
                :is-poster-loaded="isPosterLoaded"
                :online-account="onlineAccount"
            ></fields-carrefour>
            <fields
                v-else
                :is-poster-loaded="isPosterLoaded"
                :is-magazine="isMagazine"
                :sub-domain="subDomain"
                :online-account="onlineAccount"
            ></fields>
            <div class="div-btns">

              <a
                  v-if="canSubmit"
                  @click.prevent="submitPoster"
                  class="btn btn-secondary text-white waves-effect waves-light w-32 mb-2  w-sm-100"
                  data-step="11" :data-intro="'Clique em ' + this.submitLabel + ' para criar e salvar o cartaz.'">
                {{ this.submitLabel }}
              </a>
              <a
                  v-else
                  disabled
                  data-toggle="tooltip"
                  title="Este produto está sem juros! Troque a forma de pagamento."
                  class="btn btn-secondary text-white waves-effect waves-light w-32 w-sm-100 mb-2"
                  data-step="11" :data-intro="'Clique em ' + this.submitLabel + ' para criar e salvar o cartaz.'">
                {{ this.submitLabel }}
              </a>

              <slot></slot>

              <a
                  @click.prevent="clearForm"
                  class="btn btn-outline-secondary waves-effect waves-light w-32 w-sm-100 mb-2"
                  data-step="12"
                  data-intro="Clique em LIMPAR para limpar todas as informações e criar um novo cartaz do início.">
                Limpar
              </a>

            </div>
          </div>
        </div>
      </div>
      <preview
          :just-update-content="justUpdateContent"
          :campaign-description="campaignDescription"
          :sub-domain="subDomain"
      ></preview>
    </form>

    <!--    <flash-modal modal-class="modal-lg" v-show="!justUpdateContent">-->

    <!--      <template v-slot:default>-->

    <!--        <poster-limit-content></poster-limit-content>-->

    <!--      </template>-->

    <!--    </flash-modal>-->

    <span v-if="saved">salvo</span>

  </div>
</template>

<script>
import {createPoster, fetchPoster, updatePoster} from './services/poster_service.js';
import dayjs from 'dayjs';
import PosterLimitContent from './PosterLimitContent';
import FieldsCarrefour from './carrefour/FieldsCarrefour';

export default {
  props: {
    formAction: {
      type: String,
      required: true,
    },
    submitBtnLabel: {
      type: String,
      default: function () {
        return 'Salvar';
      },
    },
    posterId: {
      type: String,
    },
    subDomain: String,
    campaignDescription: {
      type: String,
      default: 'Dinâmica Comercial',
    },
    isAllowPosterCreation: false,
    isHybrid: {
      type: Boolean,
      default: () => false,
    },
    justUpdateContent: {
      type: Boolean,
      default: () => false,
    },
    isTrial: {
      type: Boolean,
      default: () => false,
    },
    createFromRegister: {
      default: () => false,
    },
    posterPermissions: Object,
    onlineAccount: Object,
  },
  data() {
    return {
      saved: false,
      isPosterLoaded: false,
      canSubmit: true,
      hasTemplateSelected: false,
      userPreferences: $.parseJSON($('#user-preferences').val()),
    };
  },

  watch: {
    submitLabel(payload) {
      this.$root.$emit('filler-submit-label', payload);
    }
  },

  computed: {
    templateImages: {
      get() {
        return this.$store.getters['selector/getTemplateImages'];
      },
      set(images) {
        this.$store.commit('selector/SET_IMAGES', images);
      },
    },
    isMagazine() {
      return this.subDomain === 'magazineluiza';
    },
    isCarrefour() {
      if (this.onlineAccount && this.onlineAccount.integration_type) {
        return this.onlineAccount.integration_type === 'carrefour';
      }
      return false;
    },
    productSelected() {
      return this.$store.getters['poster/getSelectedProduct'];
    },
    action() {
      return this.$store.state.action;
    },
    themeId() {
      return this.$store.state.poster.theme_id;
    },
    templateId() {
      return this.$store.state.poster.template_id;
    },
    submitLabel() {
      return (this.action === 'create') ? 'Criar' : 'Salvar';
    },
    posterLoaded() {
      return this.$store.state.loaded_poster;
    },
    defaultContent() {
      return this.$store.state.poster.fields.content;
    },
    posterFields() {
      if (this.$store.state.selector.template) {
        return this.$store.state.selector.template.fields.map(function (field) {
          return field.poster_field.field_id;
        });
      }
      return undefined;
    },
    postersSelected: {
      get() {
        return this.$store.getters['releasePosters/getPostersSelected'];
      },
      set(postersSelected) {
        this.$store.commit('releasePosters/SET_POSTERS_SELECTED', postersSelected);
      },
    },
    insertExpirationDates: {
      set(value) {
        this.$store.commit('poster/SET_INSERT_EXPIRATION_DATES', value);
      },
      get() {
        return this.$store.getters['poster/getInsertExpirationDates'];
      },
    },
    insertProductExpirationDates: {
      set(value) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_EXPIRATION_DATES', value);
      },
      get() {
        return this.$store.getters['poster/getInsertProductExpirationDates'];
      },
    },
    insertProductOlder: {
      set(value) {
        this.$store.commit('poster/SET_INSERT_PRODUCT_OLDER', value);
      },
      get() {
        return this.$store.getters['poster/getInsertProductOlder'];
      },
    },
    poster: {
      get() {
        return this.$store.getters['poster/field']('content');
      },
      set(content) {
        if (content) {
          this.$store.commit('poster/SET_CONTENT', content);
        }
      },
    },
    hideFieldsOnEdit() {
      return this.posterPermissions.onlySelector && this.action === 'update';
    },
  },
  components: {
    FieldsCarrefour,
    'fields': require('./Fields.vue'),
    'product': require('./Product.vue'),
    'preview': require('./Preview.vue'),
    'selector': require('./Selector.vue'),
    PosterLimitContent,
  },
  created() {
    $('.loader-search').addClass('fa fa-spinner fa-spin');
    // this.setExpirationDateInitialState();
    this.$store.commit('SET_ACTION', this.formAction);
    this.$root.$on('posterShouldCreate', () => {
      this.$store.commit('SET_ACTION', 'create');
    });
    this.$store.commit('selector/SET_IS_HYBRID', this.isHybrid);
    this.$root.$on('magazine-change-dynamic', (toggle) => this.canSubmit = toggle);
  },
  mounted() {
    if (this.justUpdateContent) {
      this.$nextTick().then(() => this.justUpdate(this));
    }
  },
  methods: {
    inTemplate(dataRole) {
      const posterContent = $('#preview').html();
      return (posterContent && _.includes(posterContent, dataRole));
    },
    justUpdate: _.debounce(function (vm) {
      vm.submitPoster(true);
    }, 14000),
    validateProduct() {
      return !this.inArray('product_code') || (this.productSelected && this.productSelected.code !== ' ');
    },
    changeFlagTemplateSelected() {
      this.hasTemplateSelected = true;
    },
    clearForm() {
      this.$store.dispatch('clearFields');
      this.$store.commit('poster/SET_SELECTED_TYPE', ' ');
      let theme = this.$store.state.selector.theme;
      this.$store.commit('selector/SET_THEME', theme);
      this.$root.$emit('clearFields');
    },
    fetchPosterToEdit(event) {
      if (this.posterId) {
        fetchPoster(this.posterId).then((poster) => {
          poster.fields.qrcode = undefined;
          poster.fields.barcode = undefined;
          poster.fields.insert_custom_qrcode = !!_.get(poster, 'fields.qr_code', false);
          poster.fields.insert_qrcode = !!_.get(poster, 'fields.qr_code', false);
          poster.fields.insert_barcode = !!_.get(poster, 'fields.bar_code', false);
          poster.fields.insert_offer_information = !!_.get(poster, 'fields.offer_information', false);
          poster.insertExpirationDates = !!_.get(poster, 'fields.valid_from', false);
          poster.insertProductExpirationDates = !!_.get(poster, 'fields.validate', false);
          poster.insertProductOlder = !!_.get(poster, 'fields.product_older', false);
          this.$store.commit('SET_POSTER', poster);
          this.$store.commit('SET_FETCHED_POSTER', poster);
          this.$store.commit('poster/SET_BRAND', poster.fields.brand);
          this.$store.commit('poster/SET_MAIN_DESCRIPTION', poster.fields.main_description);
          this.$store.commit('poster/SET_VALUE_CASH', poster.fields.value_cash);
          let theme = this.$store.getters['selector/getThemeById'](poster.theme_id);
          this.alterThemeToEdit(theme);
          this.isPosterLoaded = true;

          if (theme) {
            this.$root.$emit('releasePrintOrDownloadPoster', {
              posterId: this.posterId,
              paperFormatId: theme.paper_format_id,
            });
          }
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', error.message);
        });
      } else {
        this.isPosterLoaded = true;
      }
    },
    alterThemeToEdit(theme) {
      this.$store.commit('SET_THEME', theme);
    },
    throwPopUp(message, delay = 10) {
      this.$root.$emit('show-vueup', {
        message: message,
        color: 'white',
        backgroundColor: 'rgba(30, 30, 30, 0.5)',
        delay: delay,
      });
    },
    submitPoster(justUpdate = false) {
      if (justUpdate === true) {
        this.updatePoster(justUpdate);
      } else {
        this.$root.$emit('clean-error-form', {field: 'valid_until'});
        this.$root.$emit('clean-error-form', {field: 'valid_from'});

        if (this.needValidate() && (this.validDatesInArray() && (this.emptyValidDates() || this.invalidDates()))) {
          this.$root.$emit('error-form', {field: 'valid_until', message: 'Data inválida!'});
          this.$root.$emit('error-form', {field: 'valid_from', message: 'Data inválida!'});
          this.$root.throwFlashMessage('warning', 'Verifique os campos incorretos');
        } else if (!this.validateProduct()) {
          this.$root.throwFlashMessage('warning', 'Verifique os campos obrigatórios');
        } else if (!this.validateSelects()) {
          this.throwPopUp('Selecione todos os campos do modelo do cartaz para salvar!', 50);
        } else if (!this.validatePaymentType()) {
          this.throwPopUp('Selecione o meio de pagamento!', 50);
        } else if (!this.validateSpare() && !this.isCarrefour) {
          this.throwPopUp('O valor de \'Economize\' deve ser maior ou igual a R$0,00!', 50);
        } else if (!this.validOldAndCashValues() && !this.isCarrefour) {
          this.throwPopUp('\'Preço Promocional\' deve ser menor ou igual a \'Valor\'', 50);
        } else if (this.action === 'create') {
          this.createPoster();
        } else if (this.action === 'update') {
          this.updatePoster(justUpdate);
        }
      }
    },

    createPoster() {
      const vm = this;
      this.poster = $('#preview').html();
      createPoster(this.$store.getters['getFormFields']).then((response) => {
        this.$root.throwFlashMessage('success', response.message);

        if (!this.isAllowPosterCreation) {
          this.$store.commit('SET_ACTION', 'update');
          this.$store.commit('SET_POSTER_ID', response.data.id);
          let id = response.data.id;
          this.$root.$emit('releasePrintOrDownloadPoster', {
            posterId: id,
            paperFormatId: $('#selectFormat').find(':selected').val(),
          });
        } else {
          vm.postersSelected.push(response.data.id);
          this.$store.commit('releasePosters/SET_POSTER_ID', undefined);
        }
      }).catch((error) => {
        if (_.includes(error.message, 'Limite de cartazes atingido')) {
          return this.$root.$emit('showFlashModal');
        }
        this.$root.throwFlashMessage('danger', error.message);
      });
    },

    updatePoster(justUpdate) {
      this.poster = $('#preview').html();
      const formData = this.$store.getters['getFormFields'];
      if (!this.insertExpirationDates) {
        formData.valid_from = null;
        formData.valid_until = null;
      }

      updatePoster(this.$store.state.poster.id, formData).then((response) => {
        this.$root.throwFlashMessage('success', response.message);
        if (justUpdate)
          this.saved = true;
      }).catch((error) => {
        this.$root.throwFlashMessage('danger', error.message);
      });
    },

    validatePaymentType() {
      if (!this.inArray('payment_type')) {
        return true;
      }
      return !!this.$store.getters['poster/field']('payment_type');
    },
    inArray(data_role) {
      return (!!this.posterFields && this.posterFields.indexOf(data_role) > -1) && this.inTemplate(data_role);
    },
    validDatesInArray() {
      return (this.inArray('valid_from') && this.inArray('valid_until')) || this.inArray('valid_date_inline');
    },
    validateSelects() {
      const isSelectedTemplateSelect = $('#selectTemplate').find(':selected').length > 0;
      const isSelectedPaperFormatSelect = $('#selectFormat').find(':selected').length > 0;
      return isSelectedTemplateSelect && isSelectedPaperFormatSelect;
    },
    valueToDouble(value) {
      if (value) {
        return +value.replace('.', '').replace(',', '.');
      }
      return value;
    },
    emptyValidDates() {
      const isValidFromNotUndefined = typeof this.$store.state.poster.fields.valid_from == 'undefined';
      const isValidUntilNotUndefined = typeof this.$store.state.poster.fields.valid_until == 'undefined';
      return isValidFromNotUndefined && isValidUntilNotUndefined;
    },
    invalidDates() {
      const from = this.$store.state.poster.fields.valid_from;
      const until = this.$store.state.poster.fields.valid_until;
      return dayjs(from).isAfter(until) || dayjs(until).isBefore(from) ||
          dayjs(until).isBefore(dayjs().subtract(1, 'days'));
    },
    validOldAndCashValues() {
      let valueCash = this.$store.state.poster.fields.value_cash;
      let valueCash2 = this.$store.state.poster.fields.value_cash2;
      let valueCash3 = this.$store.state.poster.fields.value_cash3;
      let valueOld = this.$store.state.poster.fields.value_old;
      if (!this.inArray('value_cash')) {
        return true;
      }
      if (!this.inArray('value_old')) {
        return true;
      }
      if (this.inArray('unitary_value')) {
        return true;
      }
      valueCash = this.valueToDouble(valueCash);
      valueCash2 = this.valueToDouble(valueCash2);
      valueCash3 = this.valueToDouble(valueCash3);
      valueOld = this.valueToDouble(valueOld);
      return valueOld <= valueCash + valueCash2 + valueCash3;
    },
    validateSpare() {
      if (!!this.posterFields && this.posterFields.indexOf('spare') == -1) {
        return true;
      }
      const spare = this.valueToDouble(this.$store.state.poster.fields.spare);
      return spare >= 0;
    },
    needValidate() {
      return this.insertExpirationDates;
    },
    setExpirationDateInitialState() {
      this.insertExpirationDates = this.userPreferences.indexOf('requiredValidDate') !== -1 || this.isTrial;
    },
  },
};
</script>

<style>
.panel-heading {
  padding: 10px 10px 5px;
  margin: 0 15px;
}

.form-group {
  margin-bottom: 10px;
}

.form-control {
  height: 40px;
}

.panel-body {
  padding: 10px 15px 0px;
}
</style>

<style scoped>
.widget-head {
  border: 1px solid #3540512b;
  background: #D7E3E5;
  color: black;
  padding: 0 20px;
}

.panel-body {
  background-color: #fff;
  border: 1px solid #3540511f;
}

.icon-poster {
  height: 10px;
  margin: 5px;
}

.div-btns {
  padding: 15px 0;
}

.btns-poster {
  font-family: "Gotham";
  font-size: 10px;
}

.btn-clear {
  background: #354051;
}

.btn-save {
  float: right;
  background: #ED1763;
}

.btn, .btn:hover, .btn:focus {
  color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Filler.vue